import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'MapPin',
      title: 'Headquarters Address',
      content: `Endosurgery Sdn Bhd\nNo. 15, Jalan Teknologi 3/6\nTaman Sains Selangor 1\nKota Damansara\n47810 Petaling Jaya\nSelangor, Malaysia`,
      action: 'Get Directions',
      actionIcon: 'Navigation'
    },
    {
      icon: 'Phone',
      title: 'Phone Numbers',
      content: 'Main Line: +603-6157 8888\nSales Hotline: +603-6157 8889\nTechnical Support: +603-6157 8890',
      action: 'Call Now',
      actionIcon: 'Phone'
    },
    {
      icon: 'Mail',
      title: 'Email Addresses',
      content: 'General Inquiries: info@endosurgery.com.my\nSales: sales@endosurgery.com.my\nSupport: support@endosurgery.com.my',
      action: 'Send Email',
      actionIcon: 'Mail'
    },
    {
      icon: 'Clock',
      title: 'Business Hours',
      content: 'Monday - Friday: 8:30 AM - 5:30 PM\nSaturday: 8:30 AM - 1:00 PM\nSunday: Closed\n(Malaysia Standard Time - GMT+8)',
      action: null,
      actionIcon: null
    }
  ];

  const emergencyContact = {
    title: 'Emergency Medical Device Support',
    phone: '+603-6157 8899',
    description: 'Available 24/7 for urgent medical device inquiries and technical support'
  };

  return (
    <div className="space-y-6">
      {/* Main Contact Details */}
      <div className="grid gap-6">
        {contactDetails?.map((detail, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-6 shadow-medical hover:shadow-medical-hover transition-all duration-300"
          >
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
                  <Icon name={detail?.icon} size={24} color="var(--color-primary)" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-semibold text-text-primary mb-2">
                  {detail?.title}
                </h3>
                <div className="text-text-secondary whitespace-pre-line text-sm leading-relaxed mb-4">
                  {detail?.content}
                </div>
                {detail?.action && (
                  <button className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 font-medium text-sm transition-colors duration-200">
                    <Icon name={detail?.actionIcon} size={16} />
                    <span>{detail?.action}</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Emergency Contact */}
      <div className="bg-error/5 border border-error/20 rounded-lg p-6">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-12 h-12 bg-error/10 rounded-lg">
              <Icon name="AlertCircle" size={24} color="var(--color-error)" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-error mb-2">
              {emergencyContact?.title}
            </h3>
            <p className="text-text-secondary text-sm mb-3">
              {emergencyContact?.description}
            </p>
            <a
              href={`tel:${emergencyContact?.phone}`}
              className="inline-flex items-center space-x-2 bg-error text-white px-4 py-2 rounded-lg hover:bg-error/90 transition-colors duration-200 font-medium"
            >
              <Icon name="Phone" size={16} />
              <span>{emergencyContact?.phone}</span>
            </a>
          </div>
        </div>
      </div>
      {/* Social Media & Professional Networks */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Share2" size={20} className="mr-2" />
          Connect With Us
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { name: 'LinkedIn', icon: 'Linkedin', url: '#', color: 'text-blue-600' },
            { name: 'Facebook', icon: 'Facebook', url: '#', color: 'text-blue-700' },
            { name: 'Twitter', icon: 'Twitter', url: '#', color: 'text-blue-500' },
            { name: 'YouTube', icon: 'Youtube', url: '#', color: 'text-red-600' }
          ]?.map((social) => (
            <a
              key={social?.name}
              href={social?.url}
              className="flex items-center space-x-2 p-3 rounded-lg border border-border hover:bg-muted transition-colors duration-200"
            >
              <Icon name={social?.icon} size={20} className={social?.color} />
              <span className="text-sm font-medium text-text-primary">{social?.name}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;